import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import OtherPalletItem from "./OtherPalletItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_PALLETS, ON_NEW_PALLET, ON_UPDATED_PALLET} from "../../../queries/inventory";
import update from "immutability-helper";

class OtherPalletsList extends Component {

  componentDidMount() {
    this.subscribe();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe() {
    this.unsubscribe();
    this.updateSubscription = this.props.subscribeToUpdates(this.props, {});
    this.newDataSubscription = this.props.subscribeToNewData(this.props, {});
  }

  unsubscribe() {
    if (this.updateSubscription) {
      this.updateSubscription();
    }
    if (this.newDataSubscription) {
      this.newDataSubscription();
    }
  }

  render() {
    let {loading, error, pallets} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Pallet ID",
      "SKU",
      "State",
      "Items",
    ]);

    return (
      <Table 
        data={fromJS(pallets)}
        tableHeader={tableHeader} 
        renderer={OtherPalletItem} 
        selected={this.props.selectedPalletId}
        onItemClick={this.handleItemClick.bind(this)}
        itemKey="palletId"
        mode="table" />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let palletId = itemData.get("palletId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onPalletIdClick(palletId);
      return;
    }
    this.props.onSelectionChange(palletId);
  }
}


const mapDispatchToProps = dispatch => ({
  subscribeToNewData: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_PALLET,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          pallets: {
            $unshift: [subscriptionData.data.newPallet]
          }
        })
      }
    })
  },
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_PALLET,
      updateQuery: (prev, { subscriptionData }) => {
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_PALLETS, {
  options: {
    fetchPolicy: "network-only"
  }
})

export default withQuery(withSubscription(OtherPalletsList));